export default {"src":"/_next/static/media/MobileArrowLeft.fad032a8.svg","height":42,"width":14,"blurWidth":0,"blurHeight":0};